// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__1rTiA","fill":"ProgressBar_fill__3Ix05"};